// controllers/tag_controller.js
import { Controller } from "@hotwired/stimulus";
import Matter from "matter-js";

export default class extends Controller {
  static targets = ["tag"];

  connect() {
    this.engine = Matter.Engine.create();
    this.world = this.engine.world;
    this.renderer = Matter.Render.create({
      element: this.element,
      engine: this.engine,
      options: {
        width: window.innerWidth,
        height: window.innerHeight,
        wireframes: false,
        background: 'transparent'
      }
    });

    this.createBoundaries();

    this.tagTargets.forEach(tag => {
      this.addFallingTag(tag);
    });

    this.addMouseControl();

    Matter.Engine.run(this.engine);
    Matter.Render.run(this.renderer);

    Matter.Events.on(this.engine, 'afterUpdate', () => {
      this.tagTargets.forEach(tag => {
        const body = Matter.Composite.get(this.world, tag.id, 'body');
        if (body) {
          tag.style.transform = `translate(${body.position.x - tag.offsetWidth / 2}px, ${body.position.y - tag.offsetHeight / 2}px)`;
        }
      });
    });
  }

  createBoundaries() {
    const margin = 0.15 * window.innerWidth;
    const ground = Matter.Bodies.rectangle(window.innerWidth / 2, window.innerHeight + 50, window.innerWidth, 100, {
      isStatic: true,
      render: { visible: false }
    });

    const leftWall = Matter.Bodies.rectangle(-margin / 2, window.innerHeight / 2, margin, window.innerHeight, {
      isStatic: true,
      render: { visible: false }
    });

    const rightWall = Matter.Bodies.rectangle(window.innerWidth + margin / 2, window.innerHeight / 2, margin, window.innerHeight, {
      isStatic: true,
      render: { visible: false }
    });

    Matter.World.add(this.world, [ground, leftWall, rightWall]);
  }

  addFallingTag(tag) {
    tag.id = `tag-${Math.random().toString(36).substr(2, 9)}`;

    const body = Matter.Bodies.rectangle(window.innerWidth / 2, 0, tag.offsetWidth, tag.offsetHeight, {
      id: tag.id,
      render: {
        element: tag,
        fillStyle: 'transparent'
      }
    });

    const randomForceX = (Math.random() - 0.5) * 0.02;
    Matter.Body.applyForce(body, { x: body.position.x, y: body.position.y }, { x: randomForceX, y: 0 });

    Matter.World.add(this.world, body);
  }

  addMouseControl() {
    const mouse = Matter.Mouse.create(this.renderer.canvas);
    const mouseConstraint = Matter.MouseConstraint.create(this.engine, {
      mouse: mouse,
      constraint: {
        stiffness: 0.2,
        render: { visible: false }
      }
    });

    Matter.World.add(this.world, mouseConstraint);

    this.renderer.mouse = mouse;
  }
}
